import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpBackend } from '@angular/common/http';
import {
  API_LOGIN,
  USER_TOKEN,
  USER_DATA,
  API_USER,
  API_ARTISTS,
  API_USER_RECOVER_PASSWORD,
  API_USER_REGISTER_CONFIRM,
  API_USER_SEND_VALIDATION_EMAIL,
  API_USER_UPDATE_PASSWORD,
  API_USER_INFO,
  USER_INFO,
  ARTIST_INFO,
  WEB_URL_MANAGER,
  USER_TYPE_ADMIN,
  USER_TYPE_ARTIST,
  USER_TYPE_USER,
  USER_STATUS_ID,
  API_RRSS
} from '../constants';
import { environment } from 'src/environments/environment';

import { CookiesService } from 'src/app/cookies.service';
import { Subject } from 'rxjs';
import firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { UserRegistrationData, ArtistRegistrationData } from '../interfaces';
import { PopupRef } from '../components/popup/components/popup-ref';
import { PopupService } from '../components/popup/services/popup.service';
import { SimplePopupComponent } from '../components/popup/components/simple-popup/simple-popup.component';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private API_URL: any;
  private httpWithoutInterceptor: HttpClient;

  constructor(
    private http: HttpClient,
    private httpBackend: HttpBackend,
    private afAuth: AngularFireAuth,
    private popupService: PopupService
  ) {
    this.API_URL = environment.apiUrlv2
    this.httpWithoutInterceptor = new HttpClient(this.httpBackend);
  }

  public updatedStatus: Subject<boolean> = new Subject();

  async login(username: string, password: string) {
    CookiesService.initCookies();

    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      const body = { username, password };

      const response = await this.http.post(`${this.API_URL}${API_LOGIN}`, JSON.stringify(body), httpOptions).toPromise<any>();
      if (response.status === 200) {
        if (!response.data.isAdmin) {
          CookiesService.setItem(USER_TOKEN, response.data.token);
          CookiesService.setItem(USER_DATA, JSON.stringify(response.data));
        }
        CookiesService.setUserAvatar(response.data.urlAvatar);
        CookiesService.setUserLogged(true);
        CookiesService.setUserType(this.getUserType(response.data));
      }
      return response;
    } catch (err) {
      console.log(err);
      return err;
    }
  }

  logout() {
    // TODO: logout logic

  }

  private getUserType(data): string {
    if (data.isAdmin) {
      return USER_TYPE_ADMIN;
    } else if (data.isArtist) {
      if (data.statusArtist === 5) {
        return USER_TYPE_ARTIST;
      }
    }

    return USER_TYPE_USER;
  }

  async getUserInfo() {
    try {
      console.log(CookiesService.getItem(USER_TOKEN))
      let httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      const response = await this.http.get(`${this.API_URL}${API_USER}${API_USER_INFO}`, httpOptions).toPromise<any>();

      if (response.status === 200) {
        if (response.data) {
          CookiesService.setUserAvatar(response.data.avatar);
          try {
            if (response.data.avatar != null) {
              response.data.avatar = response.data.avatar + '?' + new Date().getTime();
            }
          } catch (err) { }
          CookiesService.setItem(USER_INFO, JSON.stringify(response.data));
          CookiesService.setUserType(response.data.roles.includes('ARTIST') ? 'artist' : 'user');
        }
      }

      return true;
    } catch (err) {
      console.log(err);
      return err;
    }
  }

  async getArtistInfo() {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      const response = await this.http.get(`${this.API_URL}${API_ARTISTS}${API_USER_INFO}`, httpOptions).toPromise<any>();

      if (response.status === 200) {
        if (response.data) {
          try {
            if (response.data.avatar != null) {
              response.data.avatar = response.data.avatar + '?' + new Date().getTime();
            }
          } catch (err) { }
          CookiesService.setItem(ARTIST_INFO, JSON.stringify(response.data));
          CookiesService.setItem(USER_STATUS_ID, response.data.statusArtist);
        }
      }

      return true;
    } catch (err) {
      console.log(err);
      return err;
    }
  }
  async getArtistWithoutInterceptor() {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      const response = await this.http.get(`${this.API_URL}${API_ARTISTS}${API_USER_INFO}`, httpOptions).toPromise<any>();

      if (response.status === 200) {
        if (response.data) {
          try {
            if (response.data.avatar != null) {
              response.data.avatar = response.data.avatar + '?' + new Date().getTime();
            }
          } catch (err) { }
          CookiesService.setItem(ARTIST_INFO, JSON.stringify(response.data));
          CookiesService.setItem(USER_STATUS_ID, response.data.statusArtist);
        }
      }

      return true;
    } catch (err) {
      console.log(err);
      return err;
    }
  }


  async registerUser(userData: UserRegistrationData) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      await this.http.post(`${this.API_URL}${API_USER}`, JSON.stringify(userData), httpOptions);

      return true;
    } catch (err) {
      console.log(err);

      return false;
    }
  }

  async registerArtist(artistData: ArtistRegistrationData) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      const response = await this.http.post(`${this.API_URL}${API_ARTISTS}`, JSON.stringify(artistData), httpOptions).toPromise();

      return response;
    } catch (err) {

      return err;
    }
  }

  async sendValidationEmail(email?: string, token?: string) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };
      let body;
      if (token) body = { token };
      else body = { email };

      await this.http.post(`${this.API_URL}${API_USER}${API_USER_SEND_VALIDATION_EMAIL}`, JSON.stringify(body), httpOptions).toPromise();

      return true;
    } catch (err) {
      console.log(err);

      return false;
    }
  }

  async registerConfirm(token: string) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      const body = { token };

      const response = await this.http.post(`${this.API_URL}${API_USER}${API_USER_REGISTER_CONFIRM}`, JSON.stringify(body), httpOptions).toPromise();

      return response;
    } catch (err) {
      return err;
    }
  }

  async recoverPassword(email: string) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      const body = { email };

      const response = await this.http.post(`${this.API_URL}${API_USER}${API_USER_RECOVER_PASSWORD}`, JSON.stringify(body), httpOptions).toPromise();

      return response;
    } catch (err) {
      return err;
    }
  }

  async updatePassword(id: number, password: string, token: string) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      const body = { id, password, token };

      const response = await this.http.post(`${this.API_URL}${API_USER}${API_USER_UPDATE_PASSWORD}`, JSON.stringify(body), httpOptions).toPromise();

      return response;
    } catch (err) {
      return err;
    }
  }

  async validUserEmail(email: string) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json'
        })
      };

      const response = await this.http.head(`${this.API_URL}${API_USER}/${email}`, httpOptions).toPromise();

      return response;
    } catch (err) {
      return err;
    }
  }

  async upgradeUser(artistData: ArtistRegistrationData) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + CookiesService.getItem(USER_TOKEN)
        })
      };

      const response = await this.http.post(`${this.API_URL}${API_ARTISTS}/upgradeUser`, JSON.stringify(artistData), httpOptions).toPromise();

      return response;
    } catch (err) {

      return err;
    }
  }

  async getSocialInfo(sourceId) {
    let provider = null;
    switch (sourceId) {
      case 1: //apple
        provider = new firebase.auth.OAuthProvider('apple.com');
        provider.addScope('email');
        provider.addScope('name');
        break;
      case 2: //google
        provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('https://www.googleapis.com/auth/userinfo.email');
        provider.addScope('https://www.googleapis.com/auth/user.gender.read');
        provider.addScope('https://www.googleapis.com/auth/user.birthday.read');
        break;
      case 3: //facebook
        provider = new firebase.auth.FacebookAuthProvider();
        provider.addScope('email');
        provider.addScope('user_gender');
        provider.addScope('user_birthday');
        break;
    }
    let response = null;
    return this.afAuth.signInWithPopup(provider).then(async (result) => {
      console.log("signin popup result", result)
      if (result.user) {
        const credentials = result.credential as firebase.auth.OAuthCredential;
        let additionalScopes = null;
        let avatarURL = result.user.photoURL;

        // get gender and birthday
        switch (sourceId) {
          case 2: //google
            await fetch(
              `https://people.googleapis.com/v1/people/${result.user.providerData[0].uid}?personFields=birthdays,genders&access_token=${credentials.accessToken}`,
              {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                }
              }
            ).then(function(data) {
              console.log('data from google api', data);
              if (data.ok) {
                data.json().then(dataAsJson => {
                  console.log('dataasJSON', dataAsJson);
                  let _gender = null;
                  let _birthday = null;
                  if (dataAsJson.genders && dataAsJson.genders[0] !== null) {
                    _gender = dataAsJson.genders[0].value;
                  }
                  if (dataAsJson.birthdays) {
                    const _auxbirthday = dataAsJson.birthdays[0].date;
                    _birthday = new Date(Date.UTC(_auxbirthday.year, _auxbirthday.month - 1, _auxbirthday.day)).toISOString().split('T')[0];
                  }

                  additionalScopes = {
                    gender: _gender,
                    birthday: _birthday,
                  }
                })
              }
            }).catch(function(error) {
              console.log('Request failed', error)
            });
            avatarURL = result.user.photoURL.replace('s96-c', 's256-c');
            break;
          case 3: //facebook
            let _birthDate = null;
            let _gender = null;
            if (result.additionalUserInfo.profile['birthday']) {
              _birthDate = new Date(result.additionalUserInfo.profile['birthday']);
              _birthDate.setDate(_birthDate.getDate() + 1)
              _birthDate = _birthDate.toISOString().split('T')[0];
            }
            if (result.additionalUserInfo.profile['gender']) {
              _gender = result.additionalUserInfo.profile['gender'];
            }
            additionalScopes = {
              gender: _gender,
              birthday: _birthDate,
            }
            avatarURL = result.user.photoURL + '?height=256';
            break;
        }
        // get photo
        if (avatarURL) {
          console.log('avatarurl', avatarURL);
          await this.http.get(avatarURL, {responseType: 'blob'}).subscribe(data => {
            console.log('image data', data);
            let file = new File([data],'image' + new Date().getTime(), {type: data.type});
            additionalScopes['avatar'] = file;
          })
        }

        return await firebase.auth().currentUser.getIdToken(true).then(function (data) {
          // console.log('additional Data from RRSS ', additionalScopes);
          console.log('provider data', result.user.providerData[0], 'additional scopes', additionalScopes);
          // console.log('token', data);
          response = {
            user: result.user,
            token: data,
            additionalData: additionalScopes
          }
          return response
        });
      }
    })
    .catch((error => {
      console.log("firebase signin error", error)
      if (error.code == "auth/account-exists-with-different-credential") {
        firebase.auth().fetchSignInMethodsForEmail(error.email).then((result) => {
          console.log("result fetch signin methods", result);
          let platform = result[0].split('.')[0];
          platform = platform.charAt(0).toUpperCase() + platform.slice(1);
          this.popupService.open(SimplePopupComponent, {
            data: {
              title: `Account created with ${platform}`,
              message: `Log in with this email using ${platform}`,
              buttonText: `Continue`
            }
          });
        });
      }
    }));
  }

  async loginRRSS(body: any, avatar?: File) {
    CookiesService.initCookies();

    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept-Language': 'en',
          'Channel': 'WEB'
          // 'Content-Type': 'application/json'
        })
      };

      const formData = new FormData();
      let username = body.firstName ? body.firstName : body.email;
      formData.append('email', body.email);
      formData.append('fbToken', body.fbToken);
      formData.append('firstName', username);
      formData.append('sourceId', body.sourceId);
      formData.append('sourceUserId', body.sourceUserId);
      if (body.terms) {
        formData.append('terms', body.terms);
      }
      //additional info
      console.log('avatar on loginRRSS', avatar);
      if (avatar) {
        formData.append('avatar', avatar, avatar.name);
      }
      if (body.dateOfBirth) {
        formData.append('dateOfBirth', body.dateOfBirth);
      }
      if (body.gender) {
        formData.append('gender', body.gender);
      }

      const response = await this.http.post(`${this.API_URL}${API_LOGIN}${API_RRSS}-detailed`, formData, httpOptions).toPromise<any>();
      if (response.status === 200) {
        console.log('response login', response);
        CookiesService.setItem(USER_TOKEN, response.data.token);
        CookiesService.setItem(USER_DATA, JSON.stringify(response.data));
        CookiesService.setUserAvatar(response.data.urlAvatar);
        CookiesService.setUserLogged(true);
        CookiesService.setUserType(this.getUserType(response.data));
      }
      return response;
    } catch (err) {
      console.log(err);
      return err;
    }
  }

}
